import OpportunityForm from './OpportunityForm';

export default OpportunityForm;
